import { render, staticRenderFns } from "./customerSingleModel.vue?vue&type=template&id=28ba69f2&scoped=true&"
import script from "./customerSingleModel.vue?vue&type=script&lang=js&"
export * from "./customerSingleModel.vue?vue&type=script&lang=js&"
import style0 from "./customerSingleModel.vue?vue&type=style&index=0&id=28ba69f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ba69f2",
  null
  
)

export default component.exports